// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/c" + chunkId + ".h" + "cf2af66a57c9f633" + ".js"
}